import BaseAPIService from "./BaseAPIService";
import gql from "graphql-tag";

export default class ContestService extends BaseAPIService {
  constructor() {
    super();
  }

  getContest(id) {
    return new Promise((resolve, reject) => {
      const query = require("../graphql/queries/campaign.gql");
      const variables = { id };
      this.query({ query, variables, fetchPolicy: "network-only" })
        .then((result) => {
          const returnData = result.data.campaign;
          resolve(returnData);
        })
        .catch(reject);
    });
  }

  createContest(input) {
    return new Promise((resolve, reject) => {
      const mutation = gql`
        mutation createCampaign($input: CampaignInput!) {
          createCampaign(input: $input) {
            id
          }
        }
      `;

      delete input.id;

      const variables = { input };
      this.mutate({ mutation, variables })
        .then((result) => {
          const returnData = result.data.createCampaign;
          resolve(returnData);
        })
        .catch(reject);
    });
  }

  updateContest(input) {
    return new Promise((resolve, reject) => {
      const mutation = gql`
        mutation updateCampaign($id: ID!, $input: CampaignInput!) {
          updateCampaign(id: $id, input: $input) {
            id
          }
        }
      `;
      const id = input.id;
      delete input.id;
      const variables = {
        id,
        input,
      };
      this.mutate({ mutation, variables })
        .then((result) => {
          const returnData = result.data.updateCampaign;
          resolve(returnData);
        })
        .catch(reject);
    });
  }

  deleteContest(id) {
    return new Promise((resolve, reject) => {
      const mutation = gql`
        mutation deleteCampaign($id: ID!) {
          deleteCampaign(id: $id)
        }
      `;
      const variables = { id };
      this.mutate({ mutation, variables })
        .then(() => {
          resolve();
        })
        .catch(reject);
    });
  }

  async joinCampaignManually(input) {
    const {
      companyName,
      hashtag,
      prizeTitle,
      description,
      value,
      imageFile,
      email,
      messageToOrganizer,
    } = input;
    const mutation = require("@/graphql/mutations/joinCampaignManually.gql");
    const variables = {
      input: {
        companyName,
        hashtag,
        prizeTitle,
        description,
        value: Number.isNaN(value) ? 0 : parseFloat(value),
        imageFile,
        email,
        messageToOrganizer,
      },
    };
    const res = await this.mutate({ mutation, variables });
    return res.data.joinCampaignManually;
  }

  async getCampaignExperienceApproval(id) {
    const query = require("../graphql/queries/campaignExperienceApproval.gql");
    const variables = { id };
    const options = {
      query,
      variables,
    };
    const res = await this.query(options);
    return res.data.campaignExperienceApproval;
  }

  async updateCampaignExperienceApprovalStatus(id, status) {
    const mutation = require("../graphql/mutations/updateCampaignExperienceApprovalStatus.gql");
    const variables = { id, status };
    const options = {
      mutation,
      variables,
    };
    const res = await this.mutate(options);
    return res.data.updateCampaignExperienceApprovalStatus;
  }

  async joinableCampaigns() {
    const query = require("../graphql/queries/joinableCampaigns.gql");
    const res = await this.query({
      query,
      fetchPolicy: "network-only",
    });
    return res.data.joinableCampaigns.results;
  }

  async userContents2() {
    const query = require("../graphql/queries/userContents2.gql");
    const result = await this.query({
      query,
      fetchPolicy: "network-only",
    });
    return result.data.userContents.results;
  }

  async requestCampaignExperienceApproval(
    campaignId,
    experienceId,
    message,
    prizes
  ) {
    const mutation = require("../graphql/mutations/requestCampaignExperienceApproval.gql");
    const variables = {
      campaignId,
      experienceId,
      message,
      prizes,
    };

    const result = await this.mutate({
      mutation,
      variables,
    });
    return result.data.requestCampaignExperienceApproval;
  }

  campaignExperiences(id) {
    return new Promise((resolve, reject) => {
      const query = require("../graphql/queries/campaignExperiences.gql");
      const variables = { id, limit:3, page: 1 };
      this.query({ query, variables, fetchPolicy: "network-only" })
        .then((result) => {
          const returnData = result.data.campaignExperiences;
          resolve(returnData);
        })
        .catch(reject);
    });
  }

  campaignPlatforms(id) {
    return new Promise((resolve, reject) => {
      const query = require("../graphql/queries/campaignPlatforms.gql");
      const variables = { id, limit:3, page: 1 };
      this.query({ query, variables, fetchPolicy: "network-only" })
        .then((result) => {
          const returnData = result.data.campaignPlatforms;
          resolve(returnData);
        })
        .catch(reject);
    });
  }
}
